export default __webpack_public_path__ + "static/media/bam_logo.1ad030df.png";